// extracted by mini-css-extract-plugin
export default {"login":"styles_login__Lv73K","radioText":"styles_radioText__X7w5-"};